'use client';

import { LinkedInPost } from './linkedin-post';
import { XPost } from './x-post';
import { InstagramPost } from './instagram-post';
import { VideoMedia } from './shared/video-media';
import { SocialPostActions } from './social-post-actions';

export function GenericPostToolUI({ part, status }: any) {
  const args = part.args;
  const result = part.result;

  if (status === 'loading' || !result) {
    return (
      <div className="animate-pulse p-4 border rounded-lg my-4 max-w-md mx-auto">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-muted" />
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-muted rounded w-1/3" />
            <div className="h-3 bg-muted rounded w-1/4" />
          </div>
        </div>
        <div className="mt-4 aspect-video bg-muted rounded" />
        <p className="text-sm text-muted-foreground mt-3">Creating post preview...</p>
      </div>
    );
  }

  if (!result?.success || !result.videoContext?.playbackId) {
    return null;
  }

  const platform = (result.platform || 'linkedin') as 'linkedin' | 'twitter' | 'instagram';
  const videoMedia = (
    <VideoMedia
      playbackId={result.videoContext.playbackId}
      startTime={result.videoContext.startTime}
      endTime={result.videoContext.endTime}
    />
  );

  const PostComponent = {
    linkedin: LinkedInPost,
    twitter: XPost,
    instagram: InstagramPost,
  }[platform];

  const content = result.content || args?.title || '';

  return (
    <div className="my-4 max-w-md mx-auto">
      <PostComponent authorName="Your Brand" content={content} media={videoMedia} />
      <SocialPostActions platform={platform} caption={content} />
      {result.status === 'processing' && (
        <p className="text-xs text-muted-foreground mt-2 text-center">
          Video is processing and will be ready shortly
        </p>
      )}
    </div>
  );
}
